import { trpc } from "../trpc";
import { Zap } from "./useSearchZaps";
import { useToggleZap } from "./useToggleZap";

interface Input {
  folderId?: string; // used for cache invalidation
}

export function useDisableZap(input?: Input) {
  const { folderId } = input || {};

  const { handleMutation, handleSettled, handleSuccess } = useToggleZap({
    folderId,
  });

  const mutation = trpc.zap.disable.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: () => {
      handleMutation();
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: handleSettled,
    onSuccess: (zap) => {
      handleSuccess({
        zapId: (zap as Zap)?.zapId || zap?.id || "",
        enable: false,
      });
    },
  });

  return {
    disableZap: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
